import styled, { keyframes } from 'styled-components';
import { tokens } from '../../../design/tokens';

const shimmer = keyframes`
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: 200px 0;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

export const Row = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
  padding: 12px 8px;
  border-bottom: 1px solid ${tokens.color.railGraphite};
`;

export const Cell = styled.div`
  height: 16px;
  border-radius: 4px;
  background: linear-gradient(
    90deg,
    ${tokens.color.railGraphite} 25%,
    ${tokens.color.fieldSlate} 50%,
    ${tokens.color.railGraphite} 75%
  );
  background-size: 200px 100%;
  animation: ${shimmer} 1.2s linear infinite;
`;
